

















import { Component, Vue } from 'vue-property-decorator';
import {isMobile} from '@/scripts';

@Component({
  components: {},
})
export default class About extends Vue {
  public isMobile = isMobile;
}
